import store from '@/store'
import useNotifications from '@/composables/useNotifications'
import { useRouter } from '@core/utils/utils'
import i18n from '@/libs/i18n'
import { ref } from '@vue/composition-api'
import { useLambda } from '@/views/habit/awsLambda'
import { oid } from '@/helpers/mongoHelpers'
import { hasPermission } from '@/composables/usePermission'
import useAuditLog from '@/composables/useAuditLog'

export default function useRoleAdd() {
  const userData = store.state?.userStore?.userData
  const { showSuccessMessage, showErrorMessage } = useNotifications()
  const { createItem } = useLambda()
  const { createInitialAuditEntry } = useAuditLog()
  const { router } = useRouter()
  const isSubmitting = ref(false)
  const collection = 'role'

  const storeData = async payload => {
    if (!hasPermission('organization-roles', 'create')) {
      showErrorMessage(i18n.t('message.you_are_not_authorized'))
      return
    }

    isSubmitting.value = true

    try {
      payload.client_id = oid(userData.client.$oid)
      payload.subroles = payload.subroles?.map(e => oid(e)) || []
      payload.history = [createInitialAuditEntry()]

      await createItem({ collection, payload })

      showSuccessMessage(i18n.t('message.form_success'))
    } catch (error) {
      console.log(error)
      showErrorMessage(i18n.t('message.role_error'))
    } finally {
      router.push({ name: 'organization-role-list' })
      isSubmitting.value = false
    }
  }

  return {
    storeData,
    isSubmitting,
  }
}
